angular.module("restaurants")

    .controller("RestaurantsEditCtrl", ['LoginService', '$scope', '$rootScope', '$controller', '$state', '$stateParams', 'Restangular', '$uibModal', 'modalService', '$compile', 'gridService', '$filter', '$translate', '$q', '$http',
        function (LoginService, $scope, $rootScope, $controller, $state, $stateParams, Restangular, $uibModal, modalService, $compile, gridService, $filter, $translate, $q, $http) {

            $scope.callbackFn = null;
            $scope.callback = function (callbackFn) {
                $scope.callbackFn = callbackFn;
            };

        //Comprobamos si tiene permiso escritura
        $scope.allowWrite = LoginService.permissionExist("RESTAURANTS_WRITE");
        $scope.allowFoldersFiles = LoginService.permissionExist("FILES_READ");
        $rootScope.title = $filter('translate')('restaurants.title');


        Restangular.all('Countries').getList().then(function (countries) {

            $scope.selectCountries = countries;            
        });

        if (angular.isUndefined($stateParams.id) || $stateParams.id == "") {
       
            $rootScope.breadcrumb = [
                { title: $filter('translate')('restaurants.title'), url: "restaurants.list" },
                { title: $filter('translate')('restaurants.button_add') }
            ];
            $scope.restaurant = {};

        } else {
            $rootScope.breadcrumb = [
                { title: $filter('translate')('restaurants.title'), url: "restaurants.list" },
                { title: $filter('translate')('restaurants.button_edit'), url: "restaurants.edit({ id: " + $stateParams.id + " })" },
            ];

            Restangular.one('Restaurants', $stateParams.id).get().then(function (results) {
                $scope.restaurant = results;
            });

            $scope.dateEventRestaurant = {};
            $scope.menusGrid = false;
            // Menus ofrecidos
            $scope.gridMenusOffered = {
                pdfTitle: $filter('translate')('restaurants.menus_offered'),
                exporterMenuCsv: true,
                enableGridMenu: true,
                gridMenuShowHideColumns: false,
                enableSorting: true,
                paginationPageSizes: [20, 40, 60],
                paginationPageSize: 20,
                onRegisterApi: function (gridApi) {
                    this.gridApi = gridApi;
                },
                columnDefs: [
                  { name: 'id', visible: false, enableHiding: false, exporterSuppressExport: true },
                  { name: 'event_name', displayName: $filter('translate')('restaurants.event_name'), enableFiltering: true, enableHiding: false },
                  { name: 'program_act_name', displayName: $filter('translate')('restaurants.program_act_name'), enableFiltering: true, enableHiding: false, cellTemplate: '<div ng-bind-html="row.entity[col.field] | to_trusted"></div>' },
                  {
                      name: 'date', displayName: $filter('translate')('restaurants.date'), type: 'date', cellFilter: 'date:\'dd/MM/yyyy HH:mm\'',
                      filterHeaderTemplate: '<div class="ui-grid-filter-container">' +
                                  'Desde <input ui-date="{ dateFormat: \'dd/mm/yy\', firstDay: 1, maxDate: grid.appScope.dateEventRestaurant.dateTo }" ng-change="grid.appScope.gridMenusOffered.gridApi.core.raise.itemChanged(grid.appScope);" class="form-control" id="dateFrom" ng-model="grid.appScope.dateEventRestaurant.dateFrom" required><br/>' +
                                  'Hasta <input ui-date="{ dateFormat: \'dd/mm/yy\', firstDay: 1, minDate: grid.appScope.dateEventRestaurant.dateFrom }" ng-change="grid.appScope.gridMenusOffered.gridApi.core.raise.itemChanged(grid.appScope);" class="form-control" id="dateTo" ng-model="grid.appScope.dateEventRestaurant.dateTo" required>' +
                                  '</div>',

                      enableFiltering: true, enableColumnMenu: false
                  },
                  { name: 'menu_name', displayName: $filter('translate')('restaurants.name_menu'), enableFiltering: true, enableHiding: false },                  
                ],
                getData: function (options) {
                    
                    var deferred = $q.defer();
                    options.restaurant_id = $stateParams.id;
                    if (!!$scope.dateEventRestaurant.dateFrom) options.date_from = $scope.dateEventRestaurant.dateFrom;
                    if (!!$scope.dateEventRestaurant.dateTo) options.date_to = $scope.dateEventRestaurant.dateTo;

                    $http({
                        method: 'get',
                        url: (window as any).CONFIG.api_url + 'Restaurants/MenusOffered',
                        params: options
                    }).then(function (results, status, headers, config) {
                        var data = results.data.rows;
                        data.totalRows = results.data.totalRows;

                        if (data.totalRows > 0) $scope.showgridMenusOffered = true;
                        $scope.totalRows = results.data.totalRows;
                        deferred.resolve(data);
                    });
                    return deferred.promise;
                }
            };
        }               
                                       
        $scope.save = function (frmRestaurant) {
                                                            
            if (!angular.isUndefined($scope.restaurant.id)) {
                $scope.restaurant.put().then(function (result) {
                    if (angular.isDefined(result.id)) {
                        toastr.success($filter('translate')('restaurants.edit_success'));
                        if ($scope.callbackFn != null) {
                            $scope.callbackFn(result);
                        } else {
                            $state.go("restaurants.list");
                        }
                    } else {
                        $scope.errorMessage = result.message;
                    }
                });
            } else {
                Restangular.all('Restaurants').post($scope.restaurant).then(function (result) {
                    if (angular.isDefined(result.id)) {
                        toastr.success($filter('translate')('restaurants.create_success'));
                        if ($scope.callbackFn != null) {
                            $scope.callbackFn(result);
                        } else {
                            $state.go("restaurants.edit", { id: result.id, is_template: false });
                        }
                    } else {
                        $scope.errorMessage = result.message;
                    }
                });
            }
        }

        $scope.onCancel = function () {
                if ($scope.callbackFn != null) {
                    $scope.callbackFn(null);
                } else {
                    $state.go("restaurants.list");
                }
            };

        $scope.checkDelete = function () {
            modalService.confirm({
                title: $filter('translate')('restaurants.button_delete'),
                message: $filter('translate')('restaurants.delete_message') +" "+ $scope.restaurant.name + "?",
                onAccept: function () {
                    $scope.restaurant.remove().then(function () {
                        toastr.success($filter('translate')('restaurants.delete_success'));
                        $state.go("restaurants.list");
                    });
                }
            });
        };
             

}])

;

